import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import InfoIcon from '../icons/InfoIcon';
import alertaStyles from './Alerta.styles';
import { salesChannelIs99food } from '../../../utils/check-sales-channel';

const useStyles = makeStyles((theme) => ({
  alertBoxNf: {
    ...alertaStyles.alertBox,
    justifyContent: 'space-between',
    alignSelf: 'stretch',
    backgroundColor: '#E1F9FF',
    gap: '1rem',
  },
  alertTitle: {
    ...alertaStyles.alertTitle,
    fontSize: '18px',
    fontStyle: 'normal',
  },
  alertSubtitle: {
    ...alertaStyles.alertSubtitle,
    fontSize: '16px',
  }
}));

function AlertaDevolucaoNotaFiscal({ canalDeVendas }) {
  const classes = useStyles();

  return (
    <Box className={classes.alertBoxNf}>
      <InfoIcon />
      <Box display={'flex'} flexDirection={'column'} flex={1}>
        <Typography variant="inherit" className={classes.alertTitle}>
          Devoluções de pedidos feitos pelo {canalDeVendas}.
        </Typography>
        <Typography variant="caption" className={classes.alertSubtitle}>
          As lojas Americanas não recebem devoluções nem fazem trocas para esse canal.<br />
          {salesChannelIs99food(canalDeVendas) ? `Se necessário, oriente o entregador a entrar em contato com o ${canalDeVendas} ou fale com o SAL - (11) 99149 - 2204` : `Se necessário, oriente o cliente a entrar em contato com o ${canalDeVendas} para solicitar o reembolso.`}
        </Typography>
      </Box>
    </Box>
  )
}

export default AlertaDevolucaoNotaFiscal;